
import { useContext, useEffect, useState, useMemo } from "react";
import { useOutletContext, useParams } from "react-router-dom";
import leftIcon from "resources/img/puffu/left.png";
import rightIcon from "resources/img/puffu/right.png";
import { ShoppingProcessType } from "shared/constants/constants";
// import { useCategory } from "../../process/category/CategoryContext";
import CategoryButtons from "../../process/category/CategoryButtons";
import SoldOutProductCard from "../../process/card/SoldOutProductCard";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useSelector, useDispatch } from "react-redux";
import { useTouchClick } from "shared/hooks/useTouchClick";
import HorizontalPagination from "../../process/pagination/HorizontalPagination";
import { setSelectedProductCategory, setSelectedSubCategoryId, resetCategoryState } from '../../process/category/CategoryReducer';
import { toggleDropdown, closeDropdown, setCurrentSortOption } from '../../process/category/SortingDropdownReducer';
import SkeletonProductCard from "../../process/card/SkeletonProductCard";
import style from "./HorizontalAddtoCartStep.module.css";
import SlideGuide from "./SlideGuide";
import ProductCard2 from "../../process/card/ProductCard2";
import CategoryButtons2 from "../../process/category/CategoryButtons2";
import ProductCard from "../../process/card/ProductCard";
import HorizontalTouchSlider from "../../process/pagination/HorizontalTouchSlider";
import StretchableHorizontalSlider from "../../process/pagination/StretchableHorizontalSlider";




function HorizontalAddtoCartStep2(props) {
    const { id } = useParams();
    const { isMobile } = useContext(BrowserDetectContext);
    const { viewData, setViewData, filteredProducts, currentPage, setCurrentPage, selectedCategory, subCategories, onPageChange, pagingData, fetchProductData, currentProductIndex, setCurrentProductIndex } = useOutletContext();
    const [productCategories, setProductCategories] = useState([]);
    const { currentSortOption, sortingOptions } = useSelector((state) => state.sortingDropdown);
    const { selectedProductCategory, selectedSubCategoryId } = useSelector((state) => state.category);
    const dispatch = useDispatch();
    const [isMounted, setMounted] = useState(false);
    const itemsPerPage = 10;
    const currentProcess = ShoppingProcessType.CART;
    const skeletonCount = 10;
    const [shouldShowSkeleton, setShouldShowSkeleton] = useState(false);
    const { isLoading } = useSelector((state) => ({
        isLoading: state.history.isLoading
    }));

    useEffect(() => {
        let timeout;

        if (isLoading) {
            // 로딩 시작 후 약간의 지연시간 (예: 100ms) 이후에만 스켈레톤 표시
            timeout = setTimeout(() => {
                setShouldShowSkeleton(true);
            }, 100);
        } else {
            setShouldShowSkeleton(false);
        }

        return () => clearTimeout(timeout);
    }, [isLoading]);

    useEffect(() => {
        let data = {
            title: "",
            footterButtonText: "",
            currentProcess: currentProcess,
            totalCount: 0,
            selectedCount: 0,
            priceSum: 0,
            vat: 0,
            deliveryFee: 0,
            discountSum: 0,
            totalAmount: 0,
            onDeleteSelectedProductsClick: () => { },
            onSubmitButtonClick: () => { },
            detailYn: false,
            detailProduct: null,
            slideGuide: true
        };
        setViewData((prevData) => {
            return {
                ...prevData,
                currentProcess: currentProcess
            };
        });

        setMounted(true);

    }, []);
    useEffect(() => {
        if (isMounted) {
            const timer = setTimeout(() => {
                setViewData((prevData) => ({
                    ...prevData,
                    slideGuide: false
                }));
            }, 4000);
            return () => clearTimeout(timer);
        }



    }, [isMounted])



    const totalProducts = filteredProducts.length;
    const totalPages = Math.ceil(totalProducts / itemsPerPage);

    useEffect(() => {
        if (totalPages === 0 && currentPage !== 1) {
            setCurrentPage(1);
        }
    }, [totalPages, currentPage]);

    const getCurrentPageItems = useMemo(() => {
        if (isLoading && shouldShowSkeleton) {
            return Array.from({ length: skeletonCount }).map((_, index) => (
                <SkeletonProductCard
                    key={`skeleton-${index}`}
                    flex={"1 0 17%"}
                    isLoading={true}
                />
            ));
        }

        const startIndex = (currentPage - 1) * itemsPerPage;
        const currentItems = filteredProducts.slice(startIndex, startIndex + itemsPerPage);

        // 실제 상품 데이터를 컴포넌트로 변환
        const productComponents = currentItems.map((data, index) => {
            return data.productName ? (
                data.quantity > 0 ? (
                    <ProductCard2
                        flex={"1 0 17%"}
                        data={data}
                        key={`product-${index}`}
                        index={index}
                        setViewData={setViewData}
                        currentProductIndex={currentProductIndex}
                        setCurrentProductIndex={setCurrentProductIndex}
                    />
                ) : (
                    <SoldOutProductCard
                        data={data}
                        realQuantity={data.quantity}
                        key={`soldout-${index}`}
                        setViewData={setViewData}
                        flex={"1 0 17%"}
                    />
                )
            ) : null;
        });

        // 부족한 아이템 수만큼 더미 카드 추가
        if (currentItems.length < itemsPerPage) {
            const dummyCount = itemsPerPage - currentItems.length;
            const dummyElements = Array.from({ length: dummyCount }).map((_, index) => (
                <SkeletonProductCard
                    key={`dummy-${index}`}
                    flex={"1 0 17%"}
                    isLoading={false}
                    isDummy={true}
                />
            ));
            return [...productComponents, ...dummyElements];
        }

        return productComponents;
    }, [isLoading, shouldShowSkeleton, currentPage, filteredProducts, itemsPerPage, setViewData, currentProductIndex]);

    const renderProductItems = useMemo(() => {
        return getCurrentPageItems;
    }, [getCurrentPageItems]);

    const handleProductCategorySelect = (category) => {
        // 정렬 옵션으로 카테고리를 선택한 경우
        if (sortingOptions.includes(category)) {
            fetchProductData(selectedSubCategoryId || selectedCategory, 0, category);
            setCurrentPage(1);
            return;
        }

        // 이미 선택된 카테고리를 다시 선택한 경우 (선택 해제)
        if (selectedProductCategory === category) {
            dispatch(resetCategoryState());
            fetchProductData(selectedCategory, 0, currentSortOption);
        } else {
            // 새로운 카테고리를 선택한 경우
            dispatch(setSelectedProductCategory(category));
            const subCategoryId = subCategories.find(sc => sc.categoryName === category)?.id;
            dispatch(setSelectedSubCategoryId(subCategoryId));
            fetchProductData(subCategoryId, 0, currentSortOption);

        }

        setCurrentPage(1);
    };


    const handleSlide = (deltaX) => {
        if (deltaX > 0 && pagingData.hasNext) {
            onPageChange('next');
        } else if (deltaX < 0 && pagingData.hasPrevious) {
            onPageChange('prev');
        }
    };

    const { handleTouchStart, handleTouchEnd } = useTouchClick(
        null,
        50,
        (deltaX) => handleSlide(deltaX),
        true
    );

    useEffect(() => {
        if (selectedCategory === 'all') {
            setProductCategories([]);
        } else {
            const filteredSubCategories = subCategories.filter(
                (subCategory) => subCategory.parentCategoryId === selectedCategory
            );
            const newProductCategories = filteredSubCategories.map(
                (subCategory) => subCategory.categoryName
            );
            setProductCategories(newProductCategories);
        }
    }, [selectedCategory, subCategories]);


    return (
        <div style={{
            width: "100%",
            height: "100%",
            position: "relative",
            justifyContent: "center",
            display: "flex"
        }}>
            {!isLoading && viewData.slideGuide && (
                <div style={{
                    position: "absolute",
                    top: "40%",
                    left: "37%",
                    width: "max-content",
                    zIndex: 999
                }}>
                    <SlideGuide setViewData={setViewData} />
                </div>
            )}

            <HorizontalPagination
                pagingData={pagingData}
                onPageChange={onPageChange}
                leftIcon={leftIcon}
                rightIcon={rightIcon}
                bottom='-1.3vh'
            // bottom='-21.3vh'
            />

            <div style={{ position: 'absolute', top: '30px', width: '93%' }}>
                <CategoryButtons2
                    categories={productCategories}
                    selectedProductCategory={selectedProductCategory}
                    onCategorySelect={handleProductCategorySelect}
                />
            </div>

            {/* <HorizontalTouchSlider
                children={renderProductItems}
                pagingData={pagingData}
                onPageChange={onPageChange}

            /> */}

            <StretchableHorizontalSlider
                children={renderProductItems}
                pagingData={pagingData}
                onPageChange={onPageChange}
                width='93%'
            />

        </div>
    );
}

export default HorizontalAddtoCartStep2;